import { api } from '@shared/api/api';

export const generateTimeTrackingGroupReport = (id: number) => 
	api.post('/time-tracking-groups/' + id + '/entries/export');
